import Quill from '../core/quill';
import Module from '../core/module';
import InstagramPost from '../blots/instagram';
import Delta from 'quill-delta';

class Instagram extends Module {
  constructor(...args) {
    super(...args);
    
    this.quill.clipboard.addMatcher('instagram', node => {
      if (node.dataset && node.dataset.url) {
        return new Delta().insert({instagram: node.dataset.url});
      }
      return new Delta();
    });
  }
  
  static register() {
    Quill.register(InstagramPost);
  }
}

export default Instagram;
